import Button from 'components/shared/button';
import CustomFileUpload from 'components/shared/input-field/FileUpload';
import PaySlipFileUpload from 'components/shared/input-field/PaySlipField';
import { useCallback, useState } from 'react';
import { useFormik } from 'formik';
import { Step2Props, Step4Types, step4ValidationSchema } from './utils';
import CompleteFileUpload from 'components/shared/input-field/CompleteFileUpload';
const Step4 = ({ nextStep, prevStep, handleInputDataUpdate }: Step2Props) => {
  const [loading, setLoading] = useState(false);

  const initialValues: Step4Types = {
    UtilityBill: null,
    IDCard: null,
    BankStatement: null,
    BankStatement2: null,
    BankStatement3: null,
    TenancyAgreement: null,
    PaySlip: null,
    TermsCondition: false,
  };

  const formik = useFormik<Step4Types>({
    initialValues,
    validationSchema: step4ValidationSchema,
    validateOnMount: true,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        handleInputDataUpdate(values);
        nextStep();
      } catch (err) {
        console.error('Save & Continue (Step 4) failed:', err);
      } finally {
        setLoading(false);
      }
    },
  });

  const onDropUtilityBill = useCallback(
    (acceptedFiles: File[]) => {
      const currentFile = formik.values?.UtilityBill || null;
      // Process the new file
      const filteredFile = acceptedFiles.find(
        (file) => file.size <= 5 * 1024 * 1024
      );
      if (!filteredFile) {
        formik.setFieldError(
          'UtilityBill',
          'File size is too large. Maximum size is 5MB.'
        );
        formik.setFieldTouched('UtilityBill', true, false);
      } else if (filteredFile && currentFile !== null) {
        formik.setFieldError('UtilityBill', 'You can only upload one payslip.');
        formik.setFieldTouched('UtilityBill', true, false);
        return;
      } else {
        formik.setFieldValue('UtilityBill', filteredFile);
        formik.setFieldError('UtilityBill', '');
      }
    },
    [formik]
  );

  const onDropBankStatements = useCallback(
    (acceptedFiles: File[]) => {
      const currentFile = formik.values?.BankStatement || null;

      // Process the new file
      const filteredFile = acceptedFiles.find(
        (file) => file.size <= 5 * 1024 * 1024
      );
      if (!filteredFile) {
        formik.setFieldError(
          'BankStatement',
          'File size is too large. Maximum size is 5MB.'
        );
        formik.setFieldTouched('BankStatement', true, false);
      } else if (filteredFile && currentFile !== null) {
        formik.setFieldError(
          'BankStatement',
          'You can only upload one bank statement.'
        );
        formik.setFieldTouched('BankStatement', true, false);
        return;
      } else {
        formik.setFieldValue('BankStatement', filteredFile);
        formik.setFieldError('BankStatement', '');
      }
    },
    [formik]
  );

  const onDropBankStatements1 = useCallback(
    (acceptedFiles: File[]) => {
      const currentFile = formik.values?.BankStatement2 || null;

      // Process the new file
      const filteredFile = acceptedFiles.find(
        (file) => file.size <= 5 * 1024 * 1024
      );
      if (!filteredFile) {
        formik.setFieldError(
          'BankStatement2',
          'File size is too large. Maximum size is 5MB.'
        );
        formik.setFieldTouched('BankStatement2', true, false);
      } else if (filteredFile && currentFile !== null) {
        formik.setFieldError(
          'BankStatement2',
          'You can only upload one bank statement.'
        );
        formik.setFieldTouched('BankStatement2', true, false);
        return;
      } else {
        formik.setFieldValue('BankStatement2', filteredFile);
        formik.setFieldError('BankStatement2', '');
      }
    },
    [formik]
  );

  const onDropBankStatements2 = useCallback(
    (acceptedFiles: File[]) => {
      const currentFile = formik.values?.BankStatement3 || null;

      // Process the new file
      const filteredFile = acceptedFiles.find(
        (file) => file.size <= 5 * 1024 * 1024
      );
      if (!filteredFile) {
        formik.setFieldError(
          'BankStatement3',
          'File size is too large. Maximum size is 5MB.'
        );
        formik.setFieldTouched('BankStatement3', true, false);
      } else if (filteredFile && currentFile !== null) {
        formik.setFieldError(
          'BankStatement3',
          'You can only upload one bank statement.'
        );
        formik.setFieldTouched('BankStatement3', true, false);
        return;
      } else {
        formik.setFieldValue('BankStatement3', filteredFile);
        formik.setFieldError('BankStatement3', '');
      }
    },
    [formik]
  );

  const onDropIDCard = useCallback(
    (acceptedFiles: File[]) => {
      const currentFile = formik.values?.IDCard || null;
      // Process the new file
      const filteredFile = acceptedFiles.find(
        (file) => file.size <= 5 * 1024 * 1024
      );
      if (!filteredFile) {
        formik.setFieldError(
          'IDCard',
          'File size is too large. Maximum size is 5MB.'
        );
        formik.setFieldTouched('IDCard', true, false);
      } else if (filteredFile && currentFile !== null) {
        formik.setFieldError('IDCard', 'You can only upload one id card.');
        formik.setFieldTouched('IDCard', true, false);
        return;
      } else {
        formik.setFieldValue('IDCard', filteredFile);
        formik.setFieldError('IDCard', '');
      }
    },
    [formik]
  );

  const onDropTenancyAgreement = useCallback(
    (acceptedFiles: File[]) => {
      const currentFile = formik.values?.TenancyAgreement || null;
      // Process the new file
      const filteredFile = acceptedFiles.find(
        (file) => file.size <= 5 * 1024 * 1024
      );
      if (!filteredFile) {
        formik.setFieldError(
          'TenancyAgreement',
          'File size is too large. Maximum size is 5MB.'
        );
        formik.setFieldTouched('TenancyAgreement', true, false);
      } else if (filteredFile && currentFile !== null) {
        formik.setFieldError(
          'TenancyAgreement',
          'You can only upload one tenancy agreement.'
        );
        formik.setFieldTouched('TenancyAgreement', true, false);
        return;
      } else {
        formik.setFieldValue('TenancyAgreement', filteredFile);
        formik.setFieldError('TenancyAgreement', '');
      }
    },
    [formik]
  );

  const removeDocument = (type: keyof Step4Types) => {
    formik?.setFieldValue(type, null);
    formik.setFieldTouched(type, false, false);
    formik.setFieldError(type, '');
  };

  return (
    <>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <CustomFileUpload
          label="Utility Bill (within 3 months)"
          name="UtilityBill"
          callbackfn={onDropUtilityBill}
          formik={formik}
          removeDocument={removeDocument}
        />
        <CustomFileUpload
          label="ID Card"
          name="IDCard"
          callbackfn={onDropIDCard}
          formik={formik}
          removeDocument={removeDocument}
        />
        <CustomFileUpload
          label=" 6 Months Bank Statement"
          name="BankStatement"
          callbackfn={onDropBankStatements}
          formik={formik}
          removeDocument={removeDocument}
        />
        <CustomFileUpload
          label=" Bank Statement 2 (Optional)"
          name="BankStatement2"
          callbackfn={onDropBankStatements1}
          formik={formik}
          removeDocument={removeDocument}
        />
        <CustomFileUpload
          label=" Bank Statement 3 (Optional)"
          name="BankStatement3"
          callbackfn={onDropBankStatements2}
          formik={formik}
          removeDocument={removeDocument}
        />
        <CustomFileUpload
          label="Tenancy Agreement/Offer Letter (Optional)"
          name="TenancyAgreement"
          callbackfn={onDropTenancyAgreement}
          formik={formik}
          removeDocument={removeDocument}
        />
        <CompleteFileUpload
          label="Payslip"
          name="PaySlip"
          formik={formik}
          removeDocument={removeDocument}
        />
      </div>
      <div className="mt-10 w-full justify-between flex items-center">
        <Button
          type="button"
          onClick={prevStep}
          className="bg-white border text-BrandPrimary border-BrandPrimary"
        >
          Back
        </Button>
        <Button
          type="button"
          onClick={() => formik.handleSubmit()}
          disabled={loading || !formik.isValid}
        >
          {loading ? 'Submitting' : 'Submit'}
        </Button>
      </div>
    </>
  );
};

export default Step4;
